<template>
  <div class="menu_warp">
    <div class="tit_warp">
      <span class="fontSiz14">添加</span>
      <div class="pointer fontSiz14 col-333 fontWeight" @click="closeModal()">
        <span class="iconfont icon-shanchu"></span>
      </div>
    </div>
    <div class="ibox_content scroll-view">
      <div class="inpot-row">
        <div class="input-col">
          <div class="input-lable">上级菜单</div>
          <div class="input-input">
            <el-input v-model="dataItem.pMenuName" disabled></el-input>
          </div>
        </div>

        <div class="input-col">
          <div class="input-lable">菜单类型</div>
          <div class="input-input">
            <el-radio disabled v-model="dataItem.menuType" :label="0"
              >目录</el-radio
            >
            <el-radio disabled v-model="dataItem.menuType" :label="1"
              >菜单</el-radio
            >
          </div>
        </div>
      </div>
      <div class="inpot-row">
        <div class="input-col">
          <div class="input-lable">菜单状态</div>
          <div class="input-input">
            <el-radio v-model="dataItem.menuStatus" :label="0">正常</el-radio>
            <el-radio v-model="dataItem.menuStatus" :label="1">禁用</el-radio>
          </div>
        </div>

        <div class="input-col">
          <div class="input-lable">菜单编号</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuId"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="inpot-row">
        <div class="input-col">
          <div class="input-lable">菜单名称</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuName"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>

        <div class="input-col">
          <div class="input-lable">视图名称</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuVname"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="inpot-row">
        <div class="input-col">
          <div class="input-lable">链接地址</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuUrl"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>

        <div class="input-col">
          <div class="input-lable">权限标识</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuPerms"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="inpot-row">
        <div class="input-col">
          <div class="input-lable">排序号</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuOrder"
              placeholder="请输入内容"
              type="text"
              onkeyup="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </div>
        </div>

        <div class="input-col">
          <div class="input-lable">图标</div>
          <div class="input-input" style="width: 50%">
            <el-input
              v-model="dataItem.menuIcon"
              readonly
              placeholder="请输入内容"
              disabled
            ></el-input>
          </div>

          <el-upload
            action="none"
            v-bind:show-file-list="false"
            v-bind:auto-upload="false"
            v-bind:multiple="false"
            v-bind:on-change="handleAddUploadChange"
            accept=".jpg,.jpeg,.png"
          >
            <span class="choose-btn">选择图片</span>
          </el-upload>
        </div>
      </div>
      <div class="inpot-row">
        <div class="input-col">
          <div class="input-lable">描述</div>
          <div class="input-input">
            <el-input
              v-model="dataItem.menuDescribe"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="input-col">
          <div class="input-lable">接口路径</div>
          <div class="input-input" style="width: 50%">
            <el-input
              v-model="dataItem.menuAdminUrl"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>

      <div
        class="inpot-row"
        v-if="dataItem.menuPid != '-1' && dataOperationList.length > 0"
      >
        <div class="input-operation">
          <div class="input-lable">操作</div>
          <div class="operation-warp">
            <div
              class="operation"
              v-for="(item, index) in dataOperationList"
              :key="index"
            >
              <div class="operation-input">
                <div class="operation-text">名称</div>
                <div class="operation-input-input">
                  <input type="text" v-model="item.menuName" />
                </div>
              </div>
              <div class="operation-input">
                <div class="operation-text">权限</div>
                <div class="operation-input-input">
                  <input type="text" v-model="item.menuPerms" />
                </div>
              </div>
              <div class="operation-input">
                <div class="operation-text">排序</div>
                <div class="operation-input-input">
                  <input v-model="item.menuOrder" type="number" />
                </div>
              </div>
              <div class="operation-input">
                <div class="operation-text">地址</div>
                <div class="operation-input-input">
                  <input type="text" v-model="item.menuUrl" />
                </div>
              </div>

              <div class="operation-input">
                <div class="operation-text">状态</div>
                <div class="operation-input-input operation-radio">
                  <el-radio v-model="item.menuStatus" :label="0">正常</el-radio>
                  <el-radio v-model="item.menuStatus" :label="1">禁止</el-radio>
                </div>
              </div>
              <div class="operation-btn-box">
                <div
                  v-on:click="addOperationItem(index)"
                  class="m-top10 jiahao"
                  v-if="index == dataOperationList.length - 1"
                >
                  <i
                    class="iconfont icon-jiahao"
                    style="font-size: 24px; color: #409eff"
                  >
                  </i>
                </div>
                <div v-else class="m-top10 jiahao"></div>

                <div
                  v-on:click="removeOperationItem(index)"
                  class="m-top10 jianhao"
                >
                  <i
                    class="iconfont icon-jianhao"
                    style="font-size: 24px; color: red; margin-left: 20px"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-warp flex flex-x-center">
        <span class="submit-btn" v-on:click="submitAdd()">提交</span>
      </div>
    </div>
  </div>
</template>

<script >
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  nextTick,
} from "vue";
import { imgFileToBase64, isChinese } from "@/libs/tools";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
export default defineComponent({
  name: "Add",
  props: {
    sendData: {
      type: Object,
    },
  },
  emits: ["closeModal", "getData"],
  setup(props, context) {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    const closeModal = () => {
      context.emit("closeModal");
    };
    const getData = () => {
      context.emit("getData");
    };
    const data = reactive({
      dataItem: {
        menuPid: "-1",
        pMenuName: "根目录", //父级名称
        menuType: 0, //菜单类型 "0：目录； 1：菜单； 2：按钮"
        menuStatus: 0, ////菜单状态 0 正常； 1 禁用
        menuId: "", //菜单编号
        menuName: "", //菜单名称
        menuVname: "", //视图名称
        menuUrl: "", //链接地址
        menuPerms: "", //权限标识
        menuOrder: "", //排序
        menuIcon: "", //图标
        menuDescribe: "", //描述
        menuClassify: "APP",
        menuGroup: "LOAN_ADMIN_APP_GROUP",
        menuAdminUrl: "", //接口路径
      },
      //操作添加 数组
      dataOperationList: [
        {
          menuName: "", //菜单名称
          menuPerms: "", //权限标识
          menuOrder: "", //排序
          menuUrl: "", //链接地址
          menuStatus: 0, ////菜单状态 0 正常； 1 禁用
          menuClassify: "APP",
          menuGroup: "LOAN_ADMIN_APP_GROUP",
        },
      ],
    });
    onMounted(() => {
      nextTick(() => {
        data.dataItem.pMenuName = props.sendData.pMenuName;
        data.dataItem.menuPid = props.sendData.menuPid;
        data.dataItem.menuId = props.sendData.menuId;
        data.dataItem.menuType = props.sendData.menuType;
      });
    });
    const handleAddUploadChange = (file) => {
      imgFileToBase64(file, (imageUrl) => {
        data.dataItem.menuIcon = imageUrl;
      });
    };
    // 添加菜单
    const addOperationItem = (index) => {
      if (data.dataOperationList[index].menuName == "") {
        proxy.$message.error("请输入菜单名称");
        return;
      }
      if (data.dataOperationList[index].menuPerms == "") {
        proxy.$message.error("请输入权限标识");
        return;
      }
      if (data.dataOperationList[index].menuOrder == "") {
        proxy.$message.error("请输入排序");
        return;
      }

      let obj = {
        menuName: "", //菜单名称
        menuPerms: "", //权限标识
        menuOrder: "", //排序
        menuUrl: "", //链接地址
        menuStatus: 0, ////菜单状态 0 正常； 1 禁用
        menuClassify: "APP",
        menuGroup: "LOAN_ADMIN_APP_GROUP",
      };
      data.dataOperationList.push(obj);
    };
    //删除菜单
    const removeOperationItem = (index) => {
      if (data.dataOperationList.length == 1) {
        return;
      }
      data.dataOperationList.splice(index, 1);
    };

    // 提交
    const submitAdd = async () => {
      if (data.dataItem.menuId == "") {
        proxy.$message.error("请输入菜单编号");
        return;
      }

      if (isChinese(data.dataItem.menuId) == true) {
        proxy.$message.error("菜单编号不能有汉字!");
        return;
      }
      if (data.dataItem.menuName == "") {
        proxy.$message.error("请输入视图名称");
        return;
      }
      if (data.dataItem.menuUrl == "") {
        proxy.$message.error("请输入链接地址");
        return;
      }
      if (data.dataItem.menuPerms == "") {
        proxy.$message.error("请输入权限标识");
        return;
      }
      if (data.dataItem.menuOrder == "") {
        proxy.$message.error("请输入排序");
        return;
      }
      if (data.dataItem.menuPid == "-1" && data.menuIcon == "") {
        proxy.$message.error("请选择图片");
        return;
      }

      let params = [];
      if (data.dataItem.menuPid == "-1" || data.dataItem.menuPid == -1) {
        params.push(data.dataItem);
      }
      if (data.dataItem.menuPid != "-1" || data.dataItem.menuPid != -1) {
        params.push(data.dataItem);
        let dataOperationList = data.dataOperationList;
        dataOperationList.forEach((item) => {
          item.menuPid = data.dataItem.menuId;
          item.menuType = 2;
          params.push(item);
        });
        params.forEach((item, index) => {
          if (
            item.menuName == "" &&
            item.menuPerms == "" &&
            item.menuOrder == "" &&
            item.menuUrl == ""
          ) {
            params.splice(1, index);
          }
        });
      }
      const r = await proxy.$http.post(apiObj.menuSave, params);
      if (r.respCode === "0000") {
        proxy.$message.success(r.respMsg);
        getData();
        closeModal();
      } else {
        proxy.$message.error(r.respMsg);
      }
      console.log(r);
    };
    return {
      ...toRefs(data),
      handleAddUploadChange,
      submitAdd,
      closeModal,
      getData,
      addOperationItem,
      removeOperationItem,
    };
  },
});
</script>

<style  scoped>
.menu_warp {
  width: 100%;
  height: 100%;
  background: #f5f5f4;
  overflow: auto;
}
.tit_warp {
  width: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  background-color: #fff;
  border-radius: 2px 2px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ibox_content {
  margin-top: 20px;
  padding-top: 20px;
  height: calc(100% - 100px);
  background: #ffffff;
  overflow: auto;
}
.inpot-row {
  margin: 0 15px;
  display: flex;
  justify-content: space-between;
}
.input-col {
  width: 49%;

  margin-bottom: 25px;
  display: flex;

  align-items: center;
}
.input-lable {
  width: 100px;
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-left: 50px;
  text-align: right;
}
.input-input {
  margin-left: 20px;
  width: 60%;

  text-align: left;
}

.choose-btn {
  background-color: #f8ac59;
  border-color: #f8ac59;
  color: #ffffff;
  margin-left: 10px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 5px;
}
.submit-btn {
  margin-top: 20px;
  padding: 8px 30px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  background: #293787;
  color: #ffffff !important;
  display: inline-block;
}
.input-operation {
  display: flex;
  width: 100%;
}
.operation-warp {
  padding: 15px 0;
  margin-left: 20px;
  width: 80%;
  max-height: 200px;
  border-radius: 4px;
  overflow: auto;
  border: 1px solid #dcdfe6;
}
.operation {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}
.operation-row {
  display: flex;
}
.operation-input {
  display: flex;
  width: 20%;
  height: 36px;
}
.operation-text {
  width: 50px;
  font-size: 14px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.operation-input-input {
  margin-left: 10px;
  flex: 1;
}
.operation-input-input > input {
  width: 100%;
  border: none;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 5px;
}
.operation-radio {
  display: flex;
  align-items: center;
}
.operation-btn-box {
  height: 30px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 30px;
  margin-top: 3px;
}
.btn-warp {
  width: 100%;
}
.jiahao,
.jianhao {
  width: 30px;
  height: 30px;
}
/* 选中后的字体颜色 */
:deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #293787 !important;
}
/* 选中后小圆点的颜色 */
:deep(.el-radio__input.is-checked .el-radio__inner) {
  background: #293787 !important;
  border-color: #293787 !important;
}
</style>
